module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.3@core-js/library/modules/_library.js
// module id = 48
// module chunks = 0